// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderStatus_wrapper__hht16"};